import React from 'react';
import { inject, observer } from "mobx-react";
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import LinearProgress from '@material-ui/core/LinearProgress';

import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
    root: {
      flexGrow: 1,
      minWidth: 200,
      minHeight: 300
    },
    margin: {

    },
    withoutLabel: {
      marginTop: theme.spacing.unit * 3,
    },
    textField: {
     // flexBasis: 200,
    },
    card: {
      width: '100%',
    },
    title: {
      marginBottom: 16,
      fontSize: 14,
    },
    pos: {
      marginBottom: 12,
    },
  });
  




@inject("authStore")
@observer
class CampaignBalanceDialog extends React.Component {

    state = {
      noMatch: false,
      email: '',
      newPassword: '',
      passwordVerify: '',
      verificationCode: '',
      showPassword: false,
      passwordsMatch: false,
     // passwordRequested: false,
      verificationCodeCompleted: false
    };
    componentDidMount(){
     
    }
    getStageField = () => {
      const { verificationCodeCompleted,  } = this.state
      const { passwordRequested } = this.props.authStore
      if(passwordRequested && verificationCodeCompleted ){
        return  this.makePasswordFields()
      }else if(passwordRequested && !verificationCodeCompleted){
        return this.makeCodeField()
      }else{
        return this.makeEmailField()
      }

    }

    getStageButton = () => {
      const { verificationCodeCompleted,  } = this.state
      const { passwordRequested } = this.props.authStore
      if(passwordRequested && verificationCodeCompleted ){
        return <Button disabled={this.submitDisabled()} onClick={this.handlePasswordUpdate} color="primary">Request PW Reset</Button> 
      }else if(passwordRequested && !verificationCodeCompleted){
        return <Button disabled={this.submitDisabled()} onClick={this.handleVerificationUpdate} color="primary">Submit Code</Button> 
      }else{
        return <Button disabled={this.submitDisabled()} onClick={this.requestForgotPassword} color="primary">Change Password</Button> 
      }
    }

    handleUpdate = (type, value) => {

     
      this.setState({[type]:value})

    }
    handleVerificationUpdate = () => {
      this.setState({verificationCodeCompleted: true})
    }
    handlePasswordUpdate = () => {
      const { verificationCode, newPassword, passwordVerify } = this.state

      if(verificationCode && newPassword){
        if(passwordVerify === newPassword){
            this.setState({noMatch: false})
            this.props.authStore.confirmPW(verificationCode, newPassword)
           // this.cognitoUser.confirmPassword(verificationCode, newPassword, this);
        }else{
            this.setState({noMatch: true})
        }
      }

    }
    requestForgotPassword = e => {

      const { email } = this.state 
      if(!email){
        //warn no email
        return 
      }
      this.props.authStore.setEmail(email);
      e.preventDefault();
      this.props.authStore.forgotPW()
    };
  submitDisabled = () => {
        return false
   // passwordsMatch
  }
  makeEmailField = () => {
    const { email } = this.state
    const { classes } = this.props
   return ( <TextField
    fullWidth
    required
    id="email"
    label="Email"
    className={classes.textField}
    value={email}
    onChange={(event) => this.handleUpdate('email', event.target.value)}
    margin="normal"
  />)


  }

  makeCodeField = () => {
    const { verificationCode} = this.state
    const { classes } = this.props
    return (<TextField
    required
    id="code"
    label="Verification Code"
    className={classes.textField}
    value={verificationCode}
    onChange={(event) => this.handleUpdate('verificationCode', event.target.value)}
    margin="normal"
  />)


  }

  makePasswordFields = () => {
    const { newPassword, passwordVerify, showPassword, noMatch} = this.state
    const { classes } = this.props
    return (<div>
      <TextField
      fullWidth
      id="outlined-adornment-password"
      className={classNames(classes.margin, classes.textField)}
      variant="outlined"
      type={showPassword ? 'text' : 'password'}
      label="New Password"
      value={newPassword}
      onChange={(event) => this.handleUpdate('newPassword', event.target.value)}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="Toggle password visibility"
              onClick={this.handleClickShowPassword}
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />

    <TextField
    fullWidth
    error={noMatch}
    id="outlined-adornment-passwordVerify"
    className={classNames(classes.margin, classes.textField)}
    variant="outlined"
    type={showPassword ? 'text' : 'password'}
    label="Verify Password"
    value={passwordVerify}
    onChange={(event) => this.handleUpdate('passwordVerify', event.target.value)}
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <IconButton
            aria-label="Toggle password visibility"
            onClick={this.handleClickShowPassword}
          >
            {showPassword ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </InputAdornment>
      ),
    }}
  />
</div>)
    
  }

  render() {
      const { open, close  } = this.props

    return (
  
        <Dialog
          open={open}
        //  onClose={close}
          aria-labelledby="form-dialog-title"
        >
        <DialogActions>
      </DialogActions>
          <DialogTitle id="form-dialog-title">Forgot Password </DialogTitle>
          <DialogContent>
          {this.getStageField()}
          </DialogContent>
          <DialogActions>
          <Button onClick={close} color="primary">
          Cancel
        </Button>
          {this.getStageButton()}
          </DialogActions>
        </Dialog>

    );
  }
}
//handleSubmitForgotPassword

CampaignBalanceDialog.propTypes = {
    classes: PropTypes.object.isRequired,
  };
  
export default withStyles(styles)(CampaignBalanceDialog);


// WEBPACK FOOTER //
// ./src/components/Account/ForgotPasswordDialog.js